import { Box } from '@mui/material';
import { type JSX, useState } from 'react';

import { Alert } from 'Components/Alert/Alert';
import { Button } from 'Components/Buttons/Buttons';
import { FormFieldDatePicker } from 'Components/FormField/FormFieldDatePicker/FormFieldDatePicker';
import { Modal } from 'Components/Modal/Modal';
import { Text } from 'Components/Text/Text';
import { ICON_CLOSE } from 'Config/Icons';
import { DateFilterHookValues } from 'Hooks/DateFilter';
import { DateOptionSelectOption } from 'Models/Dashboards';

import styles from './CustomDateModal.module.css';

export interface CustomDateModalProps {
    date: Date;
    hideModal: () => void;
    dateFilterHookValues: DateFilterHookValues;

    datesRestriction?: 'pastDatesOnly' | 'futureDatesOnly';
    instructions?: string;
}

/** Must be used with `useDateFilter`. */
export const CustomDateModal = (props: CustomDateModalProps): JSX.Element => {
    const [date, setDate] = useState<Date>(props.date);
    const [failureMessage, setFailureMessage] = useState<string>();

    const setCustomDate = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!date) {
            setFailureMessage('Select a date.');
        } else {
            setFailureMessage(undefined);
            // The `startDate` is a "throwaway" value that isn't used.
            props.dateFilterHookValues.updateSelection({ option: DateOptionSelectOption.CUSTOM, dateRange: { startDate: new Date(), endDate: date } });
            props.hideModal();
        }
    };

    return (
        <Modal open header="Choose a Custom Date">
            {failureMessage && <Alert type="error">{failureMessage}</Alert>}
            <Box component="form" onSubmit={setCustomDate}>
                {props.instructions && <Text>{props.instructions}</Text>}
                <div className={styles.dateContainer}>
                    <FormFieldDatePicker formFieldLabel="Date" formFieldId="date" dateFormat="MM/dd/yyyy" handleChange={setDate} selected={date} datesRestriction={props.datesRestriction} />
                </div>
                <div className={styles.modalFormButtonContainer}>
                    <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                        Close
                    </Button>
                    <Button variant="submit">Save</Button>
                </div>
            </Box>
        </Modal>
    );
};
